module.exports = __webpack_public_path__ + "media/images/default-avatar-50ae68f4220d03eaa6275ea22d593f7d.svg";